import { BrowseDialog, ColGroup } from '@104ha/base-ui';

class BrowseAPIDialog extends BrowseDialog<{ id?: number; rowData?: any }> {
	static defaultProps = {
		...BrowseDialog.defaultProps,
		title: '查詢API使用紀錄',
		width: 800,
		height: 600,
	};

	renderBody(data: any) {
		const rowData = new Proxy(this.props.rowData, {
			get(target, name) {
				return target[name] || '--';
			},
		});

		const { apiName, userAccount, userName, logDatetime, ip, apiParm, apiToken } = rowData;

		return (
			<div>
				<table className={'table table-view'}>
					<ColGroup cols={[30, 70]} />
					<tbody>
						<tr>
							<th>API名稱</th>
							<td>{apiName}</td>
						</tr>
						<tr>
							<th>API參數</th>
							<td>{apiParm}</td>
						</tr>
						<tr>
							<th>API登入帳號</th>
							<td>{userAccount}</td>
						</tr>
						<tr>
							<th>帳號名稱</th>
							<td>{userName}</td>
						</tr>
						<tr>
							<th>Access TOKEN</th>
							<td>{apiToken}</td>
						</tr>
						<tr>
							<th>登入IP</th>
							<td>{ip}</td>
						</tr>
						<tr>
							<th>操作日期時間</th>
							<td>{logDatetime}</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}
export { BrowseAPIDialog };
